'use client'
import { FunctionComponent, useCallback } from 'react'
import cn from 'classnames'
import { useSwiper } from 'swiper/react'

import { Button } from '@/components/Button'
import { Icon } from '@/icons'

import styles from './SliderNavigation.module.scss'

type SliderNavigationProps = {
  className?: string
}
export const SliderNavigation: FunctionComponent<SliderNavigationProps> = ({
  className,
}) => {
  const swiper = useSwiper()

  const next = useCallback(() => {
    swiper.slideNext()
  }, [swiper])

  const prev = useCallback(() => {
    swiper.slidePrev()
  }, [swiper])

  return (
    <div slot="wrapper-end" className={cn(className, styles.container)}>
      <Button
        variant="opacity"
        className={styles.button}
        onClick={prev}
        ariaLabel="Назад"
      >
        <Icon name="arrow" className={styles.iconPrev} />
      </Button>
      <Button
        variant="opacity"
        className={styles.button}
        onClick={next}
        ariaLabel="Вперед"
      >
        <Icon name="arrow" className={styles.iconNext} />
      </Button>
    </div>
  )
}
